import React, { useState } from 'react'

import StatisticsStartPage from './statisics-startpage'
import { StatisticsProvider } from './statistics-context'
import Statistics from './statistics'

const StatisticsPage: React.FC = () => {
  const [received, setReceived] = useState({
    data: [],
    imported: false,
  })
  const [modifiedStatistics, setModifiedStatistics] = useState([])
  const [collectiveStatistics, setCollectiveStatistics] = useState([])
  const [step, setStep] = useState(1) 
  return (
    <StatisticsProvider
      value={{
        received,
        setReceived,
        modifiedStatistics,
        setModifiedStatistics,
        collectiveStatistics,
        setCollectiveStatistics,
      }}
    >
      {step === 1 && <StatisticsStartPage setStep={setStep}/>}
      {step === 2 && <Statistics setStep={setStep}/>} 
    </StatisticsProvider>
  )
}

export default StatisticsPage
